import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alm-switch-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_switch = _resolveComponent("f-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_f_switch, {
      checked: _ctx.isChecked,
      "onUpdate:checked": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isChecked) = $event)),
        _ctx.onChange
      ]
    }, null, 8, ["checked", "onUpdate:checked"])
  ]))
}